/**
 * Mixin pickera szkół bez rodziców
 */
export const schoolPickerChildsOnlyMixin = {
  methods: {
    // @vuese
    // Akutalizuje dane szkoły
    updateSchoolData(selectedSchool) {
      this.schoolModel.schoolName.$setData(selectedSchool.name);

      if (this.schoolModel.schoolTypeDescription) {
        this.schoolModel.schoolTypeDescription.$setData(selectedSchool.typeDescription);
      }

      if (this.schoolModel.bankAccountNumber) {
        this.schoolModel.bankAccountNumber.$setData(selectedSchool.bankAccountNumber);
      }

      if (this.schoolModel.email) {
        this.schoolModel.email.$setData(selectedSchool.data?.address?.email);
      }

      if (!selectedSchool.id) {
        this.schoolModel.level?.$setData(null);
        this.schoolModel.nodeId.$setData(null);
        this.schoolModel.groupName?.$setData(null);
        this.schoolModel.groupNodeId?.$setData(null);
      } else {
        this.schoolModel.level?.$setData(selectedSchool.data.level);
        this.schoolModel.nodeId.$setData(selectedSchool.id);

        const address = selectedSchool.data.address;
        this.setAddress(address);

        if (selectedSchool.parentId && !selectedSchool.isSingle && this.schoolModel.groupNodeId) {
          this.schoolModel.groupNodeId.$setData(selectedSchool.parentId);
          this.$store.dispatch('structureNode/get', selectedSchool.parentId).then(parentNode => {
            if (this.schoolModel.groupName) {
              this.schoolModel.groupName.$setData(parentNode.name);
            } else {
              this.schoolModel.nodeId.$setData(selectedSchool.id);
              this.schoolModel.schoolName.$setData(parentNode.name);
              this.setAddress(parentNode.data.address);
            }
          });
        }
      }
    },

    // @vuese
    // Ustawia adres jednostki
    setAddress(address) {
      this.schoolModel.address.street.$setData(address.street);
      this.schoolModel.address.nr.$setData(address.houseNumber);
      this.schoolModel.address.localNr.$setData(address.flatNumber);
      this.schoolModel.address.postCode.$setData(address.postalCode);
      this.schoolModel.address.city.$setData(address.city);
    },

    // @vuese
    // Filtruje jednostki
    filterNodes(nodes) {
      return nodes.filter(node => !!node.parentId);
    }
  }
};
